const thousandsGrouped = /^-?[1-9]\d{0,2}(,\d{3})+(\.\d*)?$/;
const singleDecimalComma = /^-?\d*,\d*$/;
const plainNumber = /^-?(\d+\.?\d*|\.\d+)$/;

export const filterNumericText = (text: string): string => text.replace(/[^0-9.,-]/g, '');

export const normalizeNumericText = (text: string): string | null => {
  if (thousandsGrouped.test(text)) {
    return text.replaceAll(',', '');
  }
  if (!text.includes(',')) {
    return text;
  }
  if (singleDecimalComma.test(text)) {
    return text.replace(',', '.');
  }

  return null;
};

export const isPlainNumber = (text: string): boolean => plainNumber.test(text);

export const parseNumericText = (text: string): number =>
  isPlainNumber(text) ? Number(text) : NaN;
